module.exports = __webpack_public_path__ + "static/media/HelveticaNowText-Bold.5ab032fd.woff";